import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, forwardRef } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/common/base-components';
import { RloApplicationSearchFormHelper } from 'src/app/rm/rlo-application-search-form/rlo-application-search-form.helper';
import { FormControlTemplatesService } from 'src/app/templates/form-control-templates.service';

@Component({
  selector: 'app-fpx-searchable-dropdown',
  templateUrl: './fpx-searchable-dropdown.component.html',
  styleUrls: ['./fpx-searchable-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxSearchableDropdownComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FpxSearchableDropdownComponent extends BaseFpxControlComponent{
  @Input() disableOptionCentering: boolean = true;
  @Input() keyword: string;
  selectedData: any;
  selectedVal: string;
  template: TemplateRef<any>;
  @ViewChild('searchField', {static: true}) searchField: ElementRef;


  constructor(
    controlContainer: ControlContainer,
    changeDetectorRef: ChangeDetectorRef,
    private _fromControlTemplateService:FormControlTemplatesService,
    private _rloApplicationSearchFormHelper:RloApplicationSearchFormHelper
  ) {
    super(controlContainer, changeDetectorRef);
   }

   protected doPreInit(): void {}

   protected doPostInit(): void {
    if(this.keyword) {
      this.selectedVal = this.keyword;
      this.formControl.setValue(this.keyword);
    }
    this.searchField.nativeElement.focus();
   }

   onSelectionChange($event) {
    
   }

  onTypeChange($event) {
    this.formControl.setValue($event.target.value);
  }

   setInitialSelectedData(list: any) {
    let _selectData;
    if (this.formControl.value) {
      _selectData = list.find((option) => { return option.id === this.formControl.value });
    } else {
      _selectData = null;
    }

    this.selectedData = _selectData;
   }

   getTemplate(ngTemplateName:string): TemplateRef<any> {
    let tmplt = this._fromControlTemplateService.getTemplate(ngTemplateName, 'dropdown');
    return tmplt;
  }


}
